import { defineMessages } from "react-intl";

const messages = defineMessages({
    donate: {
        id: "donateBanner.cta",
    },
    title: {
        id: "donation.popup.title",
    },
    p1: {
        id: "donation.popup.p1"
    },
    p2: {
        id: "donation.popup.p2"
    },
    modified: {
        id: "general.modified"
    }
});

export default messages;
